import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { BUS_ASSIGNMENT_SCHEDULE_PATH } from '../../../../config/paths';
import BusAssignmentScheduleForm from './BusAssignmentScheduleForm';
import Content from '../../../layout/Content';
import {
  clearBusAssignmentSchedule,
  getBusAssignmentSchedule,
  putBusAssignmentSchedule,
} from '../../../../actions/bus/BusAssignmentSchedule';
import { tzNormalizeDate } from '../../../../utils/date';

const EditBusAssignmentSchedule = ({
  breadcrumbs,
  loading,
  dispatchGetBusAssignmentSchedule,
  dispatchClearBusAssignmentSchedule,
  busAssignmentSchedule,
  dispatchPutBusAssignmentSchedule,
  match: {
    params: { id: busAssignmentScheduleId },
  },
}) => {
  useLayoutEffect(() => {
    dispatchGetBusAssignmentSchedule({ busAssignmentScheduleId });
    return () => dispatchClearBusAssignmentSchedule();
  }, []);

  const onSubmit = (formValues) => {
    const startDate = tzNormalizeDate({
      date: formValues.startDate,
    });

    const endDate = tzNormalizeDate({
      date: formValues.endDate,
    });

    if (moment(startDate).isAfter(moment(endDate))) {
      toastr.error(
        'Error',
        'La fecha de inicio no puede ser mayor a la fecha de fin',
      );
      return;
    }

    const newFormValues = {
      circuitId: formValues.circuit.value,
      busIdList: formValues.busList.map((bus) => bus.value),
      startDate: formValues.startDate,
      endDate: formValues.endDate,
      active: formValues.active,
    };

    dispatchPutBusAssignmentSchedule(busAssignmentScheduleId, newFormValues);
  };

  const generateInitialValues = (busAssignmentScheduleJson) => ({
    circuit: {
      value: busAssignmentScheduleJson.circuit.id,
      label: `${busAssignmentScheduleJson.circuit.id} - ${busAssignmentScheduleJson.circuit.name}`,
    },
    startDate: busAssignmentScheduleJson.startDate,
    endDate: busAssignmentScheduleJson.endDate,
    busList: busAssignmentScheduleJson.busAssignmentScheduleBusList.map(
      (item) => ({
        value: item.registeredBus.id,
        label: item.registeredBus.companyBusId,
      }),
    ),
    active: busAssignmentScheduleJson.active,
  });

  let content;

  if (loading) content = <Loader />;
  else if (busAssignmentSchedule.isEmpty())
    content = <NoDataResource returnPage={BUS_ASSIGNMENT_SCHEDULE_PATH} />;
  else {
    const busAssignmentScheduleJson = busAssignmentSchedule.toJS();
    content = (
      <BusAssignmentScheduleForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(busAssignmentScheduleJson)}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Asignación de Ruta"
      content={content}
    />
  );
};

EditBusAssignmentSchedule.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetBusAssignmentSchedule: PropTypes.func.isRequired,
  dispatchClearBusAssignmentSchedule: PropTypes.func.isRequired,
  busAssignmentSchedule: PropTypes.instanceOf(Immutable.Map).isRequired,
  match: matchPropTypes.isRequired,
  dispatchPutBusAssignmentSchedule: PropTypes.func.isRequired,
};

const mapStateToProps = (
  { BusUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Asignación de Rutas',
      href: BUS_ASSIGNMENT_SCHEDULE_PATH,
    },
    {
      text: 'Editar Asignación de Rutas',
      href: `${BUS_ASSIGNMENT_SCHEDULE_PATH}/${id}`,
    },
    {
      text: 'Editar Asignación de Rutas',
      href: '',
    },
  ],
  busAssignmentSchedule: BusUnit.BusAssignmentSchedule.getIn([
    'current',
    'content',
  ]),
  loading: !BusUnit.BusAssignmentSchedule.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetBusAssignmentSchedule: getBusAssignmentSchedule,
  dispatchClearBusAssignmentSchedule: clearBusAssignmentSchedule,
  dispatchPutBusAssignmentSchedule: putBusAssignmentSchedule,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditBusAssignmentSchedule);
